import './LevelName.css';
import { getGiantOrder } from '../../../../domain/catalog/giantOrders';
import type { GiantId } from '../../map_screen/giants/giantPositions';

export type LevelNameProps = {
  id: GiantId;
  orderIndex: number;
  className?: string;
};

const WIDTH = 364 * 1.4 * 1.4;
const HEIGHT = 71;
const MID_X = WIDTH / 2;

/** Название уровня (заказа) — SVG-текст 713.44×71, top 63.5547. */
export function LevelName({ id, orderIndex, className }: LevelNameProps) {
  const name = getGiantOrder({ giantId: id, orderIndex }).title;

  return (
    <svg
      className={['level-name', className].filter(Boolean).join(' ')}
      width={WIDTH}
      height={HEIGHT}
      viewBox={`0 0 ${WIDTH} ${HEIGHT}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <text
        className="level-name__text"
        textAnchor="middle"
        x={MID_X}
        y={48}
        xmlSpace="preserve"
      >
        {name}
      </text>
    </svg>
  );
}
